import { render } from "./modalPendingProposal.vue?vue&type=template&id=1b3562a9"
import script from "./modalPendingProposal.vue?vue&type=script&lang=js"
export * from "./modalPendingProposal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__